var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MESSAGE_HIDE, MESSAGE_SHOW, TAN_REQUEST_FAILURE, TAN_REQUEST_START, TAN_REQUEST_SUCCESS, TAN_RESEND_FAILURE, TAN_RESEND_START, TAN_RESEND_SUCCESS, TAN_VALIDATE_FAILURE, TAN_VALIDATE_START, TAN_VALIDATE_SUCCESS, SHOW_FLAECHEN_TOGGLE, SAVE_BESTOCKTER_ZUGANG_VALUES, CLEAR_BESTOCKTER_ZUGANG_VALUES, SHOW_FULL_FILTER_TOGGLE, } from '../actions';
import createInitialState from '../helpers/createInitialState';
var rebflaechenNeuReducer = function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = createInitialState(); }
    switch (action.type) {
        case MESSAGE_SHOW:
            return __assign(__assign({}, state), { message: {
                    message: action.message,
                    level: action.level,
                } });
        case MESSAGE_HIDE: {
            var nextState = __assign({}, state);
            delete nextState.message;
            return nextState;
        }
        case SHOW_FLAECHEN_TOGGLE:
            return __assign(__assign({}, state), { showFlaechen: state.showFlaechen === 'aktiv' ? 'abgang' : 'aktiv' });
        case TAN_REQUEST_START:
            return __assign(__assign({}, state), { tanRequesting: true });
        case TAN_REQUEST_SUCCESS:
            return __assign(__assign({}, state), { tanRequesting: false, meldungsmodi: __assign(__assign({}, state.meldungsmodi), (_a = {}, _a[action.betriebNr] = action.meldungsmodus, _a)) });
        case TAN_REQUEST_FAILURE:
            return __assign(__assign({}, state), { tanRequesting: false });
        case TAN_VALIDATE_START:
            return __assign(__assign({}, state), { tanValidating: true });
        case TAN_VALIDATE_SUCCESS:
            return __assign(__assign({}, state), { tanValidating: false, meldungsmodi: __assign(__assign({}, state.meldungsmodi), (_b = {}, _b[action.betriebNr] = action.meldungsmodus, _b)) });
        case TAN_VALIDATE_FAILURE:
            return __assign(__assign({}, state), { tanValidating: false });
        case TAN_RESEND_START:
            return __assign(__assign({}, state), { tanResending: true });
        case TAN_RESEND_SUCCESS:
            return __assign(__assign({}, state), { tanResending: false, meldungsmodi: __assign(__assign({}, state.meldungsmodi), (_c = {}, _c[action.betriebNr] = action.meldungsmodus, _c)) });
        case TAN_RESEND_FAILURE:
            return __assign(__assign({}, state), { tanResending: false });
        case SAVE_BESTOCKTER_ZUGANG_VALUES:
            return __assign(__assign({}, state), { bestockterZugangValues: action.values });
        case CLEAR_BESTOCKTER_ZUGANG_VALUES: {
            var nextState = __assign({}, state);
            delete nextState.bestockterZugangValues;
            return nextState;
        }
        case SHOW_FULL_FILTER_TOGGLE:
            return __assign(__assign({}, state), { showFullFilter: !state.showFullFilter });
        default:
            break;
    }
    return state;
};
export default rebflaechenNeuReducer;
